import { render, staticRenderFns } from "./NhomTPDanhGiaForm.vue?vue&type=template&id=02b8d74c&"
import script from "./NhomTPDanhGiaForm.vue?vue&type=script&lang=js&"
export * from "./NhomTPDanhGiaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports